<template>
  <div class="input-autocomplete" @click.prevent>
    <div :class="{ 'input-group': !hide_dropdown }">
      <input
        ref="input"
        v-model="query"
        class="form-control"
        :placeholder="input_placeholder"
        @blur="
          () => {
            open = false
            query = ''
          }
        "
        @click="
          () => {
            open = true
            show_all = false
          }
        "
        @keydown="keydown"
      />

      <input
        v-for="(info, id) in selection"
        :key="id"
        ref="hidden"
        :name="name"
        type="hidden"
        :value="id"
      />

      <select
        v-show="!hide_dropdown"
        ref="hidden"
        class="form-select flex-grow-0"
        @click.stop.prevent="
          () => {
            open = !open || !show_all
            query = ''
            show_all = true
          }
        "
        @mousedown.stop.prevent
        @mouseup.stop.prevent
      ></select>
    </div>
    <div v-if="open && length(results)" class="autocomplete-menu no-scrollbar">
      <ul class="dropdown-list dropdown-menu d-flex flex-column">
        <li
          v-for="(info, i) in results"
          :key="i"
          class="dropdown-item onhover"
          :class="{
            selected: contains(selection, info.id),
            active: info.id == active_key,
          }"
          :style="{ order: info.score || 0 }"
          @click.stop.prevent="toggle(info)"
          @mousedown.stop.prevent
          @mouseup.stop.prevent
        >
          <a class="d-flex justify-content-between align-items-center">
            <span v-html="info.unicode" />
            <small
              :class="{
                'onhover-show-visibility': info.id != active_key,
              }"
              >{{ info.group }}</small
            >
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  contains,
  first,
  key_drop,
  last,
  length,
  map,
  merge,
  object_map,
} from "@pdfking/rfunc"
import { IsString, Keys, Values } from "@pdfking/tfunc"
import fire_event from "@pdfking/workflow/utils/fire_event"

import keyboard from "../constants/keyboard"
import can_hover from "../features/can_hover"
import search from "../mixins/search"
import strip_tags from "../utils/strip_tags"
import truncate from "../utils/truncate"

export default {
  computed: {
    active_key() {
      return Keys(this.results)[this.active]
    },
    all_options() {
      return this.options || {}
    },
    default_results() {
      if (this.show_all) {
        return this.all_options
      }

      if (this.multiple) {
        return this.selection
      }

      return null
    },

    input_placeholder() {
      const res = strip_tags(
        map(s => s.unicode, Values(this.selection)).join(", ")
      )

      if (length(this.selection) > 1) {
        return `${length(this.selection)} elementi: ${res}`
      }

      return res
    },
  },
  data() {
    return {
      active: -1,
      open: false,
      query: "",
      selection: this.options
        ? object_map(
            v => (IsString(v) ? v : v.id),
            v => (IsString(v) ? this.options[v] : v),
            this.value
          )
        : {},
      show_all: true,
    }
  },
  methods: {
    contains,
    first,
    keydown(e) {
      this.show_all = true

      switch (e.keyCode) {
        case keyboard.BACKSPACE:
          if (!this.query) {
            this.pop()
          }
          break
        case keyboard.ESCAPE:
          this.open = false
          this.query = ""
          break
        case keyboard.ARROW_DOWN:
          this.active = Math.min(
            length(this.results) - 1,
            this.active + this.open
          )
          this.open = true

          e.preventDefault()
          break
        case keyboard.ARROW_UP:
          this.active = Math.min(
            Math.max(-1, this.active - this.open),
            length(this.results) - 1
          )
          this.open = this.active >= 0

          this.query = this.open ? this.query : ""

          e.preventDefault()

          break
        case keyboard.ENTER:
          if (this.open && this.active >= 0) {
            this.toggle(Values(this.results)[this.active])
          }
          e.preventDefault()
          break
        default:
          this.open = true

          this.query = this.$refs.input.value

          break
      }
    },
    length,
    pop() {
      if (length(this.selection) > 0) {
        this.selection = key_drop(this.selection, last(Keys(this.selection)))
      }
    },
    toggle(info) {
      if (this.multiple) {
        if (contains(this.selection, info.id)) {
          this.selection = key_drop(this.selection, info.id)
        } else {
          this.selection = merge(this.selection, { [info.id]: info })
        }
      } else {
        this.open = false
        this.query = ""
        this.selection = { [info.id]: info }
      }

      if (can_hover()) this.$refs.input.focus()
    },
    truncate,
    Values,
  },
  mixins: [search],
  props: ["name", "value", "options", "disabled", "multiple"],
  watch: {
    selection() {
      this.$nextTick(() => fire_event(this.$refs.hidden, "change"))
    },
  },
}
</script>
